import { HttpClient } from 'shared/libs/http';
import { DeleteSavedJobResponse, SavedJobsIndexResponse } from './types';

export class SavedJobsApiService {
   public static async loadSavedJobs(dto: null, _opts?: {}) {
      return await HttpClient.post<SavedJobsIndexResponse>('/job/savedjob', dto);
   }

   public static async deleteSavedJob(shortListId: number) {
      return await HttpClient.post<DeleteSavedJobResponse>(`/job/deleteShortList/${shortListId}`, null);
   }
}
